import React, { useState } from 'react';
import { Row, Col, Button, Form } from "react-bootstrap"
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import commitNewObject from '../../api/commitNewObject';
import commitNewObjectLater from '../../api/commitNewObjectLater';
import getFormTemplate from "../../api/getFormTemplate";
import Loader from '../../pages/utilities/loader';
import { showToastAction } from '../../redux/toastSlice';
import { formatShortFrenchDate, frenchDateToIso, isoToFrenchDate } from '../../utils/dateUtils';
import DateInput from '../../widgets/form/DateInput';

const CreateObject = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const selectedProject = useSelector(state => state.selectedProject);
    const { form_name } = useParams();
    const { isLoading, data: template } = useQuery("getFormTemplate" + form_name, () => getFormTemplate(selectedProject.name, form_name));
    const [data, setData] = useState({});

    if (isLoading) return <><Loader /></>

    const templateData = template?.data?.data?.[0]?.template || {};
    const mappableTemplate = Object.keys(templateData).map(blockKey => {
        const block = templateData[blockKey];
        return {
            key: block.columnName,
            type: block.columnType,
            length: block.columnLength,
            pageNumber: block.page_number,
            researchKey: block.research_key,
            columnContent: block.columnContent
        };
    });

    const handleCommit = async () => {
        try {
            await commitNewObject(selectedProject.name, form_name ? form_name : name, data)
            dispatch(showToastAction({ message: "Successfully added object", showToast: true, severity: "success" }))
            history.push(`/form/${form_name}/documents`);
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }
    const handleCommitLater = async () => {
        try {
            await commitNewObjectLater(selectedProject.name, form_name, data)
            dispatch(showToastAction({ message: "Successfully added object", showToast: true, severity: "success" }))
            history.push(`/form/${form_name}/drafts`);
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    const updateData = (key, value) => setData(prev => ({ ...prev, [key]: value }));

    const getInputType = (field) => {
        if (!field || typeof field !== 'object') return 'text';
        
        const type = field.type?.toLowerCase();
        const length = field.length;
        
        if (type === 'date' || type === 'datetime') return 'date';
        if (type === 'time') return 'time';
        if (type === 'number' || type === 'integer' || type === 'float' || type === 'decimal') return 'number';
        if (type === 'email') return 'email';
        if (type === 'url' || type === 'link') return 'url';
        if (type === 'tel' || type === 'phone') return 'tel';
        if (type === 'password') return 'password';
        if (type === 'textarea' || type === 'text' && length > 100) return 'textarea';
        if (type === 'select' || type === 'dropdown' || type === 'dropdown_list') return 'select';
        if (type === 'checkbox') return 'checkbox';
        if (type === 'radio') return 'radio';
        
        return 'text';
    };

    const getFieldProps = (key, field) => {
        const inputType = getInputType(field);
        const props = {
            onChange: (e) => updateData(key, inputType === 'checkbox' ? e.target.checked : e.target.value),
            placeholder: `Enter ${key}`
        };

        if (inputType === 'number') {
            props.min = field.min || undefined;
            props.max = field.max || undefined;
            props.step = field.step || undefined;
        }
        
        if (inputType === 'text' && field.length) {
            props.maxLength = field.length;
        }

        return props;
    };

    return (
        <div className="recent-activities ml-4">
            <h3 className="border-0 mb-3">Insertion nouvelles données</h3>
            <div>
                <Form>
                    <Row className="mb-3">
                        <Col md="5">
                            <div className="top-form-wrap mb-2">
                                <div className="top-form-activities">
                                    {mappableTemplate.map((field) => {
                                        const inputType = getInputType(field);
                                        const fieldProps = getFieldProps(field.key, field);
                                        
                                        return (
                                            <Form.Group key={field.key} controlId={field.key}>
                                                <Row className="align-items-center">
                                                    <Col md="3">
                                                        <Form.Label className="mb-0">{field.key}</Form.Label>
                                                    </Col>
                                                    <Col md="9">
                                                        {inputType === 'textarea' ? (
                                                            <Form.Control
                                                                {...fieldProps}
                                                                as="textarea"
                                                                rows={3}
                                                            />
                                                        ) : inputType === 'select' ? (
                                                            <Form.Control
                                                                {...fieldProps}
                                                                as="select"
                                                            >
                                                                <option value="">Sélectionner {field.key}</option>
                                                                {field.columnContent?.map((option, index) => (
                                                                    <option key={index} value={option}>
                                                                        {option}
                                                                    </option>
                                                                ))}
                                                            </Form.Control>
                                                        ) : inputType === 'checkbox' ? (
                                                                <div className="row">
                                                                    {field.columnContent?.map((option, index) => (
                                                                        <div key={index} className="col-12 col-sm-6 col-md-4 mb-2">
                                                                            <Form.Check
                                                                                type="checkbox"
                                                                                checked={Array.isArray(data[field.key]) ? data[field.key].includes(option) : false}
                                                                                onChange={(e) => {
                                                                                    const currentValues = Array.isArray(data[field.key]) ? [...data[field.key]] : [];
                                                                                    if (e.target.checked) {
                                                                                        if (!currentValues.includes(option)) {
                                                                                            updateData(field.key, [...currentValues, option]);
                                                                                        }
                                                                                    } else {
                                                                                        updateData(field.key, currentValues.filter(val => val !== option));
                                                                                    }
                                                                                }}
                                                                                label={
                                                                                    <div 
                                                                                        style={{
                                                                                            wordBreak: 'break-word',
                                                                                            overflowWrap: 'break-word',
                                                                                            whiteSpace: 'normal',
                                                                                            display: '-webkit-box',
                                                                                            maxWidth: '100%',
                                                                                            lineHeight: '1.4',
                                                                                            padding: '0.25rem 0 0.25rem 0.5rem',
                                                                                            fontSize: '0.9rem',
                                                                                            overflow: 'hidden',
                                                                                            textOverflow: 'ellipsis',
                                                                                            WebkitLineClamp: 2,
                                                                                            WebkitBoxOrient: 'vertical'
                                                                                        }}
                                                                                        title={option}
                                                                                    >
                                                                                          {' ' + option}
                                                                                    </div>
                                                                                }
                                                                            />
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                        ) : inputType === 'radio' ? (
                                                            <div>
                                                                {field.columnContent?.map((option, index) => (
                                                                    <Form.Check
                                                                        key={index}
                                                                        type="radio"
                                                                        name={field.key}
                                                                        value={option}
                                                                        checked={data[field.key] === option}
                                                                        onChange={(e) => updateData(field.key, e.target.value)}
                                                                        label={option}
                                                                        className="mb-1"
                                                                    />
                                                                ))}
                                                            </div>
                                                        ) : inputType === 'date' ? (
                                                            <DateInput
                                                                value={data[field.key] || ''}
                                                                onChange={(e) => updateData(field.key, e.target.value)}
                                                                placeholder="jj/mm/aaaa"
                                                                disabled={false}
                                                            />
                                                        ) : (
                                                        <Form.Control 
                                                                {...fieldProps}
                                                            type={inputType} 
                                                        />
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Form.Group>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="text-center">
                                <Button
                                    className="mt-3 mr-3"
                                    variant="primary"
                                    onClick={handleCommitLater}
                                >
                                    Enregistrer comme brouillon
                                </Button>
                                <Button
                                    className="mt-3"
                                    variant="primary"
                                    onClick={handleCommit}
                                >
                                    Valider
                                </Button>
                            </div>
                        </Col>

                    </Row>



                </Form>
            </div>
        </div >
    );
}

export default CreateObject;
